module.exports = __webpack_public_path__ + "img/overview.e4f7a98d.svg";